export default {
    publisherId: "ca-pub-8612551580236582",
    bottomBannerSlot: "3575953743",
}